require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("prismjs/themes/prism-solarizedlight.css")

import { globalHistory } from '@reach/router'

export const onRouteUpdate = () => {
  globalHistory.listen(args => {
    args.location.action = args.action
  })
}
